<template>
  <div class="container_auth">
    <img
      src="../../assets/img/LMS Login Ilustrasi.png"
      alt="logo-ilustrasi"
      z-index="-1;"
      class="imgIlustrsion"
    />

    <v-col cols="12" style="height: 95vh; z-index: 0">
      <v-row no-gutters class="pa-1">
        <v-col cols="12" md="8" sm="9" xs="12">
          <div class="parentImgLogo">
            <img
              src="../../assets/img/Tanoto logo-green.png"
              class="imgLogo mr-2"
              alt="logo-tanoto-foundation"
            />
            <img
              src="../../assets/img/logo-teladan.png"
              alt="logo-teladan"
              class="imgLogo"
            />
          </div>
          <div class="mt-2">
            <p class="title_login">Learning</p>
            <p class="title_login">Management</p>
            <p class="title_login">System</p>
          </div>
        </v-col>
        <v-col cols="12" md="4" sm="3" xs="12" class="rowImgLogin">
          <form-reset />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import FormReset from "./formReset.vue";

export default {
  name: "mainGate",
  components: { FormReset },
};
</script>

<style scoped>
.parentImgLogo {
  display: flex;
  margin-top: 5px;
}
@media (max-width: 900px) {
  .parentImgLogo {
    display: flex;
    margin-top: 5px;
  }
}
.imgLogo {
  height: 40px;
}
@media (max-width: 900px) {
  .imgLogo {
    height: 40px;
  }
}
.form_login {
  min-height: 95vh;
  z-index: 2;
  position: absolute;
  width: 100%;
  padding-right: 5%;
  padding-left: 5%;
}

.rowImgLogin {
  display: flex;
  align-items: center;
  height: 95vh;
}
@media (max-width: 900px) {
  .rowImgLogin {
    align-items: flex-start;
    justify-content: center;
  }
}
.imglogin {
  width: 70%;
  padding-left: 40px;
  padding-right: 40px;
  max-height: 95vh;
}
.parentImgLogin {
  display: flex;
}

@media (max-width: 900px) {
  .parentImgLogin {
    align-items: flex-start;
  }
}

.imgIlustrsion {
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: 5vh;
  display: flex;
}
@media (max-width: 900px) {
  .imgIlustrsion {
    position: absolute;
    left: 15%;
    right: 15%;
    bottom: -5vh;
    display: flex;
    width: 70%;
  }
}
.title_login {
  color: #8ed3b7;
  font-weight: bold;
  text-align: left;
  font-size: 200%;
  line-height: 80%;
}
@media (max-width: 900px) {
  .title_login {
    color: #8ed3b7;
    font-weight: bold;
    text-align: left;
    font-size: 100%;
    line-height: 80%;
  }
}
.temp_form {
  z-index: 2 !important;
  align-items: flex-end;
  justify-items: flex-end;
  width: 100%;
}
.temp-boba {
  position: absolute;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  top: 0;
}
@media (max-width: 1282px) {
  .boba1 {
    width: 200px;
    height: 200px;
  }
  .boba2 {
    width: 400px;
    height: 400px;
  }
  .boba3 {
    width: 300px;
    height: 300px;
  }
  .boba4 {
    width: 200px;
    height: 200px;
    bottom: 0;
  }
}
@media (max-width: 1030px) {
  .boba1 {
    width: 150px;
    height: 150px;
  }
  .boba2 {
    width: 350px;
    height: 350px;
  }
  .boba3 {
    width: 250px;
    height: 250px;
  }
  .boba4 {
    width: 150px;
    height: 150px;
  }
}
@media (max-width: 932px) {
  .boba1 {
    width: 130px;
    height: 130px;
  }
  .boba2 {
    width: 330px;
    height: 330px;
  }
  .boba3 {
    width: 230px;
    height: 230px;
  }
  .boba4 {
    width: 130px;
    height: 130px;
  }
}
@media (max-width: 850px) {
  .boba1 {
    width: 100px;
    height: 100px;
  }
  .boba2 {
    width: 200px;
    height: 200px;
  }
  .boba3 {
    width: 150px;
    height: 150px;
  }
  .boba4 {
    width: 100px;
    height: 100px;
  }
}
@media (max-width: 730px) {
  .boba1 {
    width: 70px;
    height: 70px;
  }
  .boba2 {
    width: 150px;
    height: 150px;
  }
  .boba3 {
    width: 100px;
    height: 100px;
  }
  .boba4 {
    width: 70px;
    height: 70px;
  }
}
</style>
